import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import { RecommendationListMiniCart } from './RecommendationListMiniCart.js';
import { RecommendationListPage } from './RecommendationListPage.js';

const componentMap = {
    page: RecommendationListPage,
    minicart: RecommendationListMiniCart
};
const RecommendationListContainer = ({ layout ='minicart' , loading , recommendations ,  })=>{
    const { getLabel  } = useIntl();
    if (loading || !recommendations.length) {
        return null;
    }
    const Component = componentMap[layout] || RecommendationListMiniCart;
    const labels = {
        title: getLabel('products.recommendationList.title')
    };
    return /*#__PURE__*/ React.createElement(Component, {
        labels: labels,
        recommendations: recommendations,
        className: `recommendation-list-${layout}-layout`
    });
};

export { RecommendationListContainer };
//# sourceMappingURL=RecommendationListContainer.js.map
